import { Box } from '@factorialco/deprecated-design-system'
import { DataTableFilter, FilterType } from 'generated/resources/datatable.graphql'
import { ContactFragment, FinanceFinancialDocumentFilter } from 'generated/resources/graphql'

import { Filter } from 'modules/core/components/DataTable/types'
import useFilter from 'modules/core/components/Filter/base/useFilter'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { FinanceContactsSelector } from 'modules/finance/components/Contacts/FinanceContactsSelector'
import { InvoiceFilters } from 'modules/finance/components/Invoices/DataTableWrapper/types'

const VendorsFilterComponent = () => {
  const { value, onValueChange } = useFilter<ContactFragment[]>()
  const { company } = useCurrentSession()
  const companyId = company.id

  return (
    <Box width="s400" flexDirection="column" overflowY="hidden" overflowX="hidden" hideScrollBar>
      <FinanceContactsSelector
        multiple
        alwaysOpen
        value={value ?? []}
        onSelect={onValueChange}
        type="finance_contact"
        queryParams={{
          companyId: companyId,
          contactSearchType: 'vendor',
        }}
        variant={'gamma'}
      />
    </Box>
  )
}

const createVendorFilterConfig = (
  onUpdateVendorFilter: (filter?: Filter<number[]>) => void,
  currentVendorIds?: string[]
): DataTableFilter<FinanceFinancialDocumentFilter> => {
  return {
    identifier: 'vendor_id',
    title: i18n.t('finance.invoices.list.fields.vendor'),
    path: 'vendorId',
    type: FilterType.Entity,
    default: Boolean(currentVendorIds?.length),
    onUpdateValue: onUpdateVendorFilter,
    categories: [
      {
        kind: 'Entity',
        operation: 'in',
        nameAttribute: 'name',
        value: currentVendorIds || [],
        component: () => <VendorsFilterComponent />,
      },
    ],
  }
}

export const vendorFilter = (
  onFilterChange: (filters: InvoiceFilters) => void = () => {},
  currentVendorIds?: string[]
): DataTableFilter<FinanceFinancialDocumentFilter> => {
  const onUpdateVendorFilter = (filter?: Filter<number[]>) => {
    const filterValue = Array.isArray(filter?.value) ? filter.value : []
    onFilterChange({ vendorIds: filterValue })
  }

  return createVendorFilterConfig(onUpdateVendorFilter, currentVendorIds)
}
